/* eslint-disable react-refresh/only-export-components */

/* eslint-disable no-irregular-whitespace */
import Brandmark from "@/components/logo/Brandmark";
import { EMLogo } from "@/components/logo/EMLogo";
import { ReactNode } from "react";
import {
  CLEAN_HEAT_PARTNERS_CUSTOM_URL_HOST,
  CLEAN_HEAT_PARTNERS_ORGANIZATION_ID,
  ENERGY_MACHINES_CUSTOM_URL_HOST,
  ENERGY_MACHINES_ORGANIZATION_ID,
  SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST,
  SIMULATE_ENERGY_MACHINES_ORGANIZATION_ID,
  WEDOSCM_CUSTOM_URL_HOST
} from "./BrandLabelConstants";
import emFavIcon from "./brand-favicons/em-fave.ico";
import { CleanHeatPartnersLogo } from "./clean-heat-partners/CleanHeatPartnersLogo";
import cleanHeatPartnersFavIcon from "./clean-heat-partners/clean-heat-partners-fav.ico";

type WhiteLabelBase = {
  id?: string;
  name: string;
  hostname: string;
  cookieDomain: string;
  brandWebsite: string;
  title: string;
  Logo: () => JSX.Element;
  favIcon: string;
  configID: string;
};

type WhiteLabelLandingPageDisabled = WhiteLabelBase & {
  brandHexColor?: never;
  hasLandingPageEnabled: false;
  LandingPageLogo?: never;
  landingPageSubtitle?: never;
  landingPageWelcomeText?: never;
};

export type WhiteLabelLandingPageEnabled = WhiteLabelBase & {
  brandColorHex?: string;
  hasLandingPageEnabled: true;
  LandingPageLogo: () => JSX.Element;
  landingPageSubtitle: string;
  landingPageWelcomeText: ReactNode;
};

export type WhiteLabelBrand =
  | WhiteLabelLandingPageDisabled
  | WhiteLabelLandingPageEnabled;

const WhiteLabelBrands: Readonly<{ [key: string]: WhiteLabelBrand }> =
  Object.freeze({
    [SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST]: {
      id: SIMULATE_ENERGY_MACHINES_ORGANIZATION_ID,
      hostname: SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST,
      cookieDomain: ".energymachines.com",
      name: "energy-machines",
      brandWebsite: "https://www.energymachines.com/",
      title: "Energy Machines",
      Logo: EMLogo,
      favIcon: emFavIcon,
      hasLandingPageEnabled: true,
      brandColorHex: "#000",
      LandingPageLogo: () => (
        <div className="bg-black flex items-center justify-center w-9 h-9 text-white">
          <EMLogo />
        </div>
      ),
      landingPageSubtitle: "Simulation platform",
      landingPageWelcomeText: (
        <>
          Welcome to EM Simulate, the platform for designing Energy Machines™
          energy systems and heat pumps.
          <br />
          <br />
          If you are an Energy Machines employee, sign in to access our suite of
          design and dimensioning tools and create, simulate, and monitor
          state-of-the-art energy solution designs.
          <br />
          <br />
          Together, we can accelerate the transition to sustainable energy.
        </>
      ),
      configID: import.meta.env.VITE_ENERGY_MACHINES_WHITE_LABEL_ID
    },
    [ENERGY_MACHINES_CUSTOM_URL_HOST]: {
      id: ENERGY_MACHINES_ORGANIZATION_ID,
      hostname: ENERGY_MACHINES_CUSTOM_URL_HOST,
      cookieDomain: ".energymachines.com",
      name: "energy-machines",
      brandWebsite: "https://www.energymachines.com/",
      title: "Energy Machines",
      Logo: EMLogo,
      favIcon: emFavIcon,
      hasLandingPageEnabled: false,
      configID: import.meta.env.VITE_ENERGY_MACHINES_WHITE_LABEL_ID
    },
    [CLEAN_HEAT_PARTNERS_CUSTOM_URL_HOST]: {
      id: CLEAN_HEAT_PARTNERS_ORGANIZATION_ID,
      hostname: CLEAN_HEAT_PARTNERS_CUSTOM_URL_HOST,
      cookieDomain: ".cleanheatpartners.com",
      name: "clean-heat-partners",
      brandWebsite: "https://www.cleanheatpartners.com/",
      title: "Clean Heat Partners",
      Logo: CleanHeatPartnersLogo,
      favIcon: cleanHeatPartnersFavIcon,
      hasLandingPageEnabled: true,
      brandColorHex: "#00998b",
      LandingPageLogo: () => (
        <img
          className=""
          src="/clean_heat_partners_32.png"
          alt="Clean Heat Partners logo"
        />
      ),
      landingPageSubtitle:
        "Solutions to design and optimise your heating plant operations",
      landingPageWelcomeText: (
        <>
          Welcome to Clean Heat Partners platform for digital design and
          verification of heating plant operations.
          <br />
          <br />
          Take control of your heating plant with our smart autopilot -
          constantly monitoring conditions, predicting what&apos;s coming next,
          and automatically adjusting operations to deliver the best possible
          performance at the lowest cost.
        </>
      ),
      configID: import.meta.env.VITE_CLEAN_HEAT_PARTNERS_WHITE_LABEL_ID
    },
    [WEDOSCM_CUSTOM_URL_HOST]: {
      id: undefined,
      hostname: WEDOSCM_CUSTOM_URL_HOST,
      cookieDomain: ".wedoscm.com",
      name: "wedoscm",
      brandWebsite: "https://www.wedoscm.com/",
      title: "WeDoSCM",
      Logo: Brandmark,
      favIcon: "",
      hasLandingPageEnabled: false,
      configID: import.meta.env.VITE_WE_DO_SCM_WHITE_LABEL_ID
    }
  });

export const getWhiteLabelBrand = () => {
  const host = window.location.hostname;

  if (host in WhiteLabelBrands) return WhiteLabelBrands[host];
  return undefined;
};
